<div class="container-sm">

  <h2>Reenter Password</h2>

  <p>Great! You can now enter a new password. We need it to be more than 8 characters.</p>

  <form (ngSubmit)="reset(f)" #f="ngForm" novalidate>

    <div class="form-group">
      <label for="input-password">Password</label>
      <input type="password" class="form-control has-feedback" id="input-password" name="password"
             [(ngModel)]="password"
             #passwordInput="ngModel"
             [ngClass]="{ 'is-invalid': passwordInput.invalid && (passwordInput.dirty || passwordInput.touched || f.submitted )}"
             required
             minlength="8"
      >
      <div *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched || f.submitted )" class="invalid-feedback">
        <div *ngIf="passwordInput.errors['required']">You forgot to enter your password.</div>
        <div *ngIf="passwordInput.errors['minlength']">We need a password of at least {{ passwordInput.errors.minlength.requiredLength }} characters.</div>
      </div>
      <small class="form-text text-muted" *ngIf="!passwordInput.value">Please at least 8 characters.</small>
    </div>
    <div class="form-group is-invalid">
      <label for="input-password-again">Repeat password</label>
      <input type="password" class="form-control" id="input-password-again" name="password_confirmation"
             [(ngModel)]="password_confirmation"
             #passwordConfirmationInput="ngModel"
             [ngClass]="{ 'is-invalid': passwordConfirmationInput.invalid && (passwordConfirmationInput.dirty || passwordConfirmationInput.touched || f.submitted) }"
             required
             appEquals="password"
      >
      <div *ngIf="passwordConfirmationInput.invalid && (passwordConfirmationInput.dirty || passwordConfirmationInput.touched || f.submitted)" class="invalid-feedback">
        <div *ngIf="passwordConfirmationInput.errors['notequal']">Passwords must be the same!.</div>
      </div>
    </div>


    <button type="submit" class="btn btn-lg btn-block btn-primary">Send</button>

  </form>

</div>
